// extracted by mini-css-extract-plugin
export default {"zGoTop":"800","zDownloadGame":"500","zNavGroup":"700"};